import React from "react";
import { Progress, Card, Row, Col, Form } from "antd";
import { OHeader, OThemeText, SingleLine } from "../text/OText";
import Metrics from "../../theme/Metrics";
import OCard from "./index";
import NumberUtil from "../../util/number";
import ProgressBar from "../bar/ProgressBar";

const ProgressSession = ({style, value,
	label, 
	fontSize = Metrics.fontSize.h1,
	//max, 
	//showMax = true,
	//seperator = '/', 
	//pureNumber = true,
})=>(
	<div>
		<div style={{
			display:"flex", 
			justifyContent:"space-between",
			paddingBottom:Metrics.button.spaceMargin,
			fontWeight:Metrics.boldFontWeight,
			fontSize,
		}}>
			<OHeader style={{fontSize}}>{`${label}`}</OHeader>
			<OThemeText>
				{value}
				{/* {pureNumber ? value : NumberUtil.numberToUnit(value)} */}
			</OThemeText>
			{/* showMax ? <OHeader>{`${seperator}${pureNumber ? max : NumberUtil.numberToUnit(max)}`}</OHeader> : undefined */}
		</div>
		{/* <ProgressBar radius={Metrics.progressBar.bigStorkeWidth / 2} percent={100*value/max} /> */}
	</div>
);
export default ProgressSession;


// WEBPACK FOOTER //
// ./src/components/card/ProgressSession.js